//TODO remove console logs

import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { HashRouter as Router, Route, Link } from 'react-router-dom';
import Store from './store';
import { Provider } from 'react-redux';

import TimeSince from './components/screens/TimeSince';
import GenderSelect from './components/screens/GenderSelect';
import routes from './config/routes';
import './styles/styles.scss';

Store.subscribe(()=>{
    console.log('store changed', Store.getState());
});

class App extends Component {
    render() {
        return (
            <Router>
                <div className="ec-content">
                    <Route exact path='/' component={ GenderSelect } />
                    {routes.map((route, i) => <Route key={i} {...route} />)}
                </div>
            </Router>
        )
    }
}

ReactDOM.render(
    <Provider store={Store}>
        <App/>
    </Provider>,
    document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js